import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'transaction-history';

export default {
    receipts: (id) => {
        return axios.get(`${base.baseUrl}/${namespace}/receipts/${id}`)
    },
}
